import { v } from "convex/values";

export const GLOBAL_PROCESSING_PENDING = "pending";
export const GLOBAL_PROCESSING_PROCESSING = "processing";
export const GLOBAL_PROCESSING_COMPLETED = "completed";
export const GLOBAL_PROCESSING_FAILED = "failed";

export const GLOBAL_PROCESSING_STATES = [
  GLOBAL_PROCESSING_PENDING,
  GLOBAL_PROCESSING_PROCESSING,
  GLOBAL_PROCESSING_COMPLETED,
  GLOBAL_PROCESSING_FAILED,
] as const;

export type GlobalProcessingState = (typeof GLOBAL_PROCESSING_STATES)[number];

export const globalProcessingStateValidator = v.union(
  v.literal(GLOBAL_PROCESSING_PENDING),
  v.literal(GLOBAL_PROCESSING_PROCESSING),
  v.literal(GLOBAL_PROCESSING_COMPLETED),
  v.literal(GLOBAL_PROCESSING_FAILED)
);

const globalProcessingStateSet = new Set<string>(GLOBAL_PROCESSING_STATES);

export function isGlobalProcessingState(value: unknown): value is GlobalProcessingState {
  return typeof value === "string" && globalProcessingStateSet.has(value);
}
